// extracted by mini-css-extract-plugin
export default {"container":"GlobalMessages_container__kFMbE","toast":"GlobalMessages_toast__OxjGT"};